import { useNotification } from "hooks/notification"
import React, { useEffect, useState } from "react"
import { translate } from "translate/i18n"
import { getRequest } from "utils/request"
import { toast } from "react-toastify"

export function InstagramLoginButton(): JSX.Element {
  const { selectedCompany } = useNotification()
  const [authLink, setAuthLink] = useState("")

  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text)
    toast.info(translate("successCopy"))
  }

  useEffect(() => {
    getRequest<{ instagramAuthorizationLink: string }>(
      `/instagramcallback/request-company-authorization?companyId=${selectedCompany.id}`
    ).then((response) => {
      if (response.success) {
        setAuthLink(response.data.instagramAuthorizationLink)
      }
    })
  }, [selectedCompany.id])

  return (
    <>
      <textarea
        // type="text"
        className="form-control"
        style={{ marginTop: 20, resize: "none" }}
        defaultValue={authLink}
        disabled
      />
      <button
        style={{ top: 147, right: 30 }}
        type="button"
        className="copyButton"
        onClick={() => handleCopy(authLink)}
      >
        <i className="far fa-copy" style={{ fontSize: 20 }}></i>
      </button>
    </>
  )
}
